import { render } from "./OrdersCompleted.vue?vue&type=template&id=4ed34a93"
import script from "./OrdersCompleted.vue?vue&type=script&lang=ts"
export * from "./OrdersCompleted.vue?vue&type=script&lang=ts"
script.render = render

export default script